// src/app/modules/user/components/modals/AssignDeviceModal.tsx
import React, {useState} from 'react'
import GenericDropdown, {GenericItem} from '../common/GenericDropdown'
import PrimaryButton from '../common/buttons/PrimaryButton'
import {OwnershipType} from '../../../../entities/device.entity'

interface FormValues {
  id: number
  ownershipType: OwnershipType
  device_id: number
}

interface AssignDeviceModalProps {
  isOpen: boolean
  onClose: () => void
  handleSubmit: (values: FormValues, resetForm: () => void) => void
  selectedDevice: any
  doctorsList: GenericItem[] // now strongly-typed
  isAssignDeviceLoading: boolean
}

const AssignDeviceModal: React.FC<AssignDeviceModalProps> = ({
  isOpen,
  onClose,
  handleSubmit,
  selectedDevice,
  doctorsList,
  isAssignDeviceLoading = false,
}) => {
  const [selectedDoctor, setSelectedDoctor] = useState<number | null>(null)
  const [ownershipType, setOwnershipType] = useState<OwnershipType>('rental')

  // when the user picks a doctor…
  const handleDoctorSelect = (id: number) => {
    setSelectedDoctor(id)
  }

  const handleSave = () => {
    if (selectedDoctor !== null) {
      handleSubmit(
        {
          id: selectedDoctor,
          ownershipType,
          device_id: selectedDevice.id,
        },
        () => {
          // reset local state after successful assign
          setSelectedDoctor(null)
          setOwnershipType('rental')
        }
      )
    }
  }

  const user = selectedDevice?.DoctorAllocatedDevices[0]?.User || {}
  const fullName = [user.first_name, user.last_name].filter(Boolean).join(' ')

  return (
    <>
      {isOpen && (
        <div
          onClick={onClose}
          className='modal-backdrop show'
          style={{backgroundColor: 'rgba(0, 0, 0, 0.5)'}}
        />
      )}
      <div className={`modal fade ${isOpen ? 'show d-block' : ''}`} tabIndex={-1}>
        <div className='modal-dialog modal-dialog-centered'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h5 className='modal-title'>Assign Device to Doctor</h5>
              <button type='button' className='btn-close' onClick={onClose} />
            </div>
            <div className='modal-body'>
              {user.email ? (
                <>
                  <h6 className='text-center'>Device Already Assigned to: {fullName}</h6>
                  <p className='text-center'>Go to Doctor devices to unassign</p>
                </>
              ) : (
                <>
                  <h5>Doctors</h5>
                  <GenericDropdown
                    items={doctorsList.filter(doctor => doctor.status === 1)}
                    selectedId={selectedDoctor}
                    onSelect={handleDoctorSelect}
                    placeholder='Select a doctor'
                  />

                  <div className='mt-3'>
                    <h5>Ownership Type</h5>
                    <div className='form-check form-check-inline'>
                      <input
                        type='radio'
                        name='ownershipType'
                        value='rental'
                        className='form-check-input'
                        id='rental'
                        checked={ownershipType === 'rental'}
                        onChange={() => setOwnershipType('rental')}
                      />
                      <label className='form-check-label text-black' htmlFor='rental'>
                        Rental
                      </label>
                    </div>
                    <div className='form-check form-check-inline'>
                      <input
                        type='radio'
                        name='ownershipType'
                        value='purchased'
                        className='form-check-input'
                        id='purchased'
                        checked={ownershipType === 'purchased'}
                        onChange={() => setOwnershipType('purchased')}
                      />
                      <label className='form-check-label text-black' htmlFor='purchased'>
                        Purchased
                      </label>
                    </div>
                    <div className='form-check form-check-inline'>
                      <input
                        type='radio'
                        name='ownershipType'
                        value='loaned'
                        className='form-check-input'
                        id='loaned'
                        checked={ownershipType === 'loaned'}
                        onChange={() => setOwnershipType('loaned')}
                      />
                      <label className='form-check-label text-black' htmlFor='loaned'>
                        Loaned
                      </label>
                    </div>
                  </div>
                </>
              )}
            </div>

            {!user.email && (
              <div className='modal-footer'>
                <PrimaryButton className='' disabled={isAssignDeviceLoading} onClick={handleSave}>
                  {!isAssignDeviceLoading ? (
                    <span className='indicator-label'>Assign</span>
                  ) : (
                    <span className='indicator-progress' style={{display: 'block'}}>
                      Assigning...
                      <span className='spinner-border spinner-border-sm align-middle ms-2' />
                    </span>
                  )}
                </PrimaryButton>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default AssignDeviceModal
